import {Injectable} from '@angular/core';
/**
 * Created by Rumyantsev Daniil on 25.02.2019.
 */

@Injectable()
export class MeteringUnitConversionService {

  public convert(meteringUnit: string): string {
    if(meteringUnit == null) { return "";}

    if(meteringUnit == 'Кубометр') { return ' м³'; }

    return meteringUnit;
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/metering-unit-conversion.service.ts